<template>
    <div class="branding-preview">
        <div>
            <div class="branding-preview__explanation">
                <text-decorator :size="Size.xs" bold>
                    Weergave in jouw huisstijl:
                </text-decorator>
            </div>
            <div class="branding-preview__logo">
                <img
                    :src="imageURL"
                    alt="Logo"
                    style="object-fit: contain"
                />
            </div>
            <div class="branding-preview__header" :style="{ backgroundColor: props.values.secondaryColor }">
                <div>
                    <img
                        width="100%"
                        height="100%"
                        min-height="300px"
                        :src="BrandingPreviewImage"
                        alt="DemoImage preview"
                    />
                </div>
            </div>

            <div class="branding-preview__content">
                <text-heading :style="{ fontFamily: headingFont, color: props.values.primaryColor } ">
                    Tekstkoppen worden op deze manier weergeven
                </text-heading>
                <text-description :style="{ fontFamily: textFont, color: props.values.textColor } ">
                    Dit is hoe de tekst getoond wordt op basis van jouw huisstijl
                </text-description>

                <button
                    type="button"
                    disabled
                    :style="{ backgroundColor: props.values.buttonColor, color: props.values.buttonTextColor }"
                >
                    Dit is een knop
                </button>
            </div>

            <div class="branding-preview__footer">
                <horizontal-line />

                <div>
                    <a
                        v-for="i in 9"
                        :key="i"
                        :style="{ color: props.values.linkColor }"
                        href="#"
                    >
                        &bull; Dit is een tekst link
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { Form } from '@/company/brand/components/BrandForm.vue';
    import BrandingPreviewImage from '@/company/brand/assets/branding-preview-image.jpg';
    import BrandingPreviewLogo from '@/company/brand/assets/branding-preview-logo.png';
    import { computed } from 'vue';
    import { Size } from '@keyvue/one-ui';

    const props = defineProps<{
        values: Form
    }>();

    const headingFont = computed(() => {
        const fontName = props.values.headingFontName?.name.replace(/\+/g, ' ');
        const fallback = props.values.headingFontName?.fallback;

        return `"${fontName}", ${fallback}`;
    });

    const textFont = computed(() => {
        const fontName = props.values.fontName?.name.replace(/\+/g, ' ');
        const fallback = props.values.fontName?.fallback;

        return `"${fontName}", ${fallback}`;
    });

    const imageURL = computed(() => {
        return props.values.logo?.url ? props.values.logo.url : BrandingPreviewLogo;
    });
</script>

<style scoped lang="scss">
.branding-preview {
    height: 100%;
    width: 100%;
    border-left: 3px solid color(gray-200);
    display: grid;

    &__explanation {
        padding: size(md);
        border-bottom: 2px solid color(gray-100);
        align-content: center;
    }

    &__logo {
        display: flex;
        justify-content: center;
        padding: size(md) 0;

        & > img {
            width: 25%;
        }
    }

    &__header {
        padding: size(md);
        margin: 0 size(md);

        & > div {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            background-color: color(gray-200);

            & > svg {
                width: 75px;
                color: white;
            }
        }
    }

    &__content {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: size(xl);

        & > button {
            margin-top: size(md);
            border: 0;
            outline: 0;

            font-size: font-size(md);

            border-radius: size(xs);
            padding: size(sm) size(xl);
        }
    }

    &__footer {
        display: flex;
        flex-direction: column;

        padding: size(md);

        & > div {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            grid-auto-rows: 40px;
            width: 100%;
            background-color: color(gray-200);

            & > a {
                width: 100%;
                height: 100%;
                padding: size(sm);
                box-sizing: border-box;
            }
        }
    }
}
</style>
